import { $http, Constants } from "@/store/actions/constants";

const url = `${Constants.BaseURL}/workflow/template`;

const urlWorkflowToDo = `${Constants.BaseURL}/workflow/workflowTodo`;

export const WorkflowActions = {

    find: ({ commit, state }, search) => {
        return $http.get(url, { ...state.authHeader, params: search }).then(r => {
            if (r.status === 200) {
                commit("SET_WORKFLOWS", r.data);
            }
        });
    },

    create: ({ dispatch, commit, state }, tt) => {
        let len = state.workflows.filter(e => e.type === tt && e.type !== 'Custom').length;
        if (len === 0) {
            return $http.post(`${url}/create?type=${tt}`, {}, state.authHeader).then(r => {
                if (r.status === 200) {
                    dispatch("workflowFind", { limit: 10, offset: 0 });
                }
            });
        }
    },

    edit: ({ commit, state }, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit("UPDATE_WORKFLOW", data.data);
            }
        });
    },

    delete: ({ commit, state }, id) => {
        if (id) {
            return $http.delete(`${url}/${id}`, state.authHeader).then(r => {
                if (r.status === 200) {
                    commit("DELETE_WORKFLOW", id);
                }
            });
        }
    },

    get: ({ _, state }, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },

    getWorkflowToDos: ({ commit, state }, search) => {
        return $http.get(urlWorkflowToDo, { ...state.authHeader, params: search });
    }
};